export default __webpack_public_path__ + "static/media/img-slider-urban-transit-4.43815a03.png";